import { Component, OnInit, ElementRef, Renderer2, ViewChild, ViewContainerRef, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
// import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips';

import { BaseService } from '../../shared/services/base.service';
import { AppService } from '../../shared/services/app.service';
import { LoaderService } from '../../../base/services/loader.service';
import { AlertsService } from '../../../base/services/alerts.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-dash-board',
    templateUrl: './dash-board.component.html',
    styleUrls: ['./dash-board.component.scss'],
    standalone: false
})
export class DashBoardComponent implements OnInit {
  @Input() type: string = '';
  public _currentWidgets: any = [];
  public _viewInit: Boolean = false;
  public _topKeys: String[] = [];
  public _bottomKeys: String[] = [];
  hasSubscription = new Subscription();

  @ViewChild('topWidgetSelection', { read: ViewContainerRef }) topWidSelection: ViewContainerRef;
  @ViewChild('bottomWidgetSelection', { read: ViewContainerRef }) bottomWidSelection: ViewContainerRef;
  constructor(
    public baseService: BaseService,
    public loaderService: LoaderService,
    public alertsService: AlertsService,
    public appService: AppService,
    public route: ActivatedRoute,
  ) {

  }

  ngOnInit() {
    this.appService.setLocationAwareConfig(true);
    if (this.appService._widgets == undefined) {
      //calll widget get api here.
    } else {
      //build widget here.
      this.getAllWidgets();
    }
    if (localStorage.getItem("notificationId") == undefined) {
      // this.getPermissionforNotify(this.auth.getCurrentUser()['user_id']) //here i call to save token corresponding to user isd In db
      
      //this.alertPermission() //it will show the mesage to allow turn on notification by saurav deep
    }

    // this.messagingService.receiveMessage()
    // this.messagingService.getPayload().subscribe(result => {
    //   console.log("message is :: 1", result);
    //   if (result) {
    //     var action = result.data.action;
    //     if (action.toLowerCase() == 'videocallstart') {
    //       const initialState = { data: result };
    //       this.smartModalService.show(TelemedicineModalComponent, { initialState });
    //     } else if (action.toLowerCase() == 'videocallend') {
    //       this.smartModalService.hide(1)
    //     }
    //   }
    // })
  }


  public getAllWidgets() {
    var dashboardType = '';
    if (this.type) {
      dashboardType = this.type;
    } else if (this.route.snapshot.data.type != undefined && this.appService._widgets[this.route.snapshot.data.type] != undefined) {
      dashboardType = this.route.snapshot.data.type;
    }
    if (dashboardType) {
      if (this.appService._widgets[dashboardType].length) {
        let allPromiseObj: any = [];
        for (let widget of this.appService._widgets[dashboardType]) {

          allPromiseObj.push(this.asyncProcess(widget));
        }

        Promise.all(allPromiseObj).then(() => {
          this.initSlider();
          setTimeout(() => {
            this._viewInit = true;
          });
          if (this._currentWidgets.top != undefined) {
            this._topKeys = Object.keys(this._currentWidgets.top).sort((a, b) => { return this._currentWidgets.top[a].order - this._currentWidgets.top[b].order })
          }
          if (this._currentWidgets.bottom != undefined) {
            this._bottomKeys = Object.keys(this._currentWidgets.bottom).sort((a, b) => { return this._currentWidgets.bottom[a].order - this._currentWidgets.bottom[b].order })
          }
          console.log(this._currentWidgets);
        });
      }
    }
  }

  // private alertPermission() {
  //   if (Notification.permission !== 'granted') {
  //     this.alertsService.info("For better experience please turn on notification");
  //   }
  // }

  ngOnDestroy() {
    this.hasSubscription.unsubscribe();
  }

  public getPermissionforNotify(userId: any) {
    //to get permission to save toejn in databse by saurav deep user_id
    // const userId = 'user001';

  }

  initSlider() {
    let slider: any = document.querySelector('.isscrollable');
    let isDown = false;
    let startX;
    let scrollLeft;
    if (slider) {
      slider.addEventListener('mousedown', (e: any) => {
        isDown = true;
        slider.classList.add('active');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });
      slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.classList.remove('active');
      });
      slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.classList.remove('active');
      });
      slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 3; //scroll-fast
        slider.scrollLeft = scrollLeft - walk;
        //console.log(walk);
      });


    }
  }
  //added by abhinav chauhan to enable dashboard cards scroll on click
  //scroll right
  triggerDCScrollRight(event) {
    //console.log('clickeddd');
    var dashboard_card_container = document.getElementById('isScrollable');
    dashboard_card_container.scrollBy(250, 0);
  }
  //scroll left
  triggerDCScrollLeft(event) {
    //console.log('clickeddd');
    var dashboard_card_container = document.getElementById('isScrollable');
    dashboard_card_container.scrollBy(-250, 0);
  }
  asyncProcess(widget) {
    return new Promise<void>((resolve, reject) => {
      if (widget) {
        this.baseService.getResourceDef(widget, (currentResouceDef) => {
          if (currentResouceDef && currentResouceDef.section != undefined) {
            if (this._currentWidgets[currentResouceDef.section] == undefined) {
              this._currentWidgets[currentResouceDef.section] = {};
            }

            if (this._currentWidgets[currentResouceDef.section][widget] == undefined) {
              this._currentWidgets[currentResouceDef.section][widget] = {};
            }
            this._currentWidgets[currentResouceDef.section][widget] = currentResouceDef;
          }
          resolve();
        });
      }

    });
  }
}